import {Button, Form} from "react-bootstrap";
import statesList from "../../../util/statesList";
import checkIcon from "../../../assets/check.svg";
import React, {useEffect, useState} from "react";
import {cloneDeep, isEqual} from 'lodash';
import ApiService from "../../../ApiService";
import {clinicianIdFromRefreshAuth} from "../../../util/authUtil";
import {parseAxiosError} from "../../../util/parserHelper";
import {licenceEventProps} from "../../Profile";


const LicenseEditRow = ({license, eventListener, toggleLoading, switchToDisplayMode}) => {

    const [licenceClone, setLicenceClone] = useState(cloneDeep(license));
    const [clinicianId, setClinicianId] = useState(null);

    useEffect(() => {
        clinicianIdFromRefreshAuth().then(id => setClinicianId(id));
    }, []);

    const handleConfirmChange = async () => {
        if (isEqual(license, licenceClone)) {
            eventListener({type: licenceEventProps.errType, name: "", message: "No change in license details to update"});
            return;
        }

        let callPromise;
        toggleLoading(true);
        if(licenceClone?.isNewAdd === true){
            callPromise = ApiService.addClinicianLicence(licenceClone);
        } else {
            callPromise = ApiService.updateClinicianLicence(licenceClone);
        }
        callPromise.then(res => {
                eventListener({type: licenceEventProps.infoType,
                    message: "Updated license details successfully",
                    name: licenceEventProps.event_clinicianProfileUpdated,
                    profile: res?.data
                });
                switchToDisplayMode();
            }).catch(err => {
                eventListener({type: licenceEventProps.errType,
                    name: "",
                    message: `Licence update failed. ${parseAxiosError(err)?.message ?? 'unknown error'}`
                });
            }).finally(() => toggleLoading(false));
    }

    const handleDiscardChanges = () => {
        const base = {
            type: licenceEventProps.infoType,
            name: licenceEventProps.event_licenseEditOrAddDiscard,
            license: license,
        };
        isEqual(license, licenceClone)
            ? eventListener({...base, message: "Cancelled license update. No changes found anyway"})
            : eventListener({...base, message: "Cancelled license update"});
        switchToDisplayMode();
    };

    return (
      <>
        <tr style={{ background: 'transparent' }} className="TableRow">
          <td>
            <Form.Group controlId="licenseState">
              <Form.Select defaultValue={licenceClone?.state || ''} onChange={e => (licenceClone.state = e.target.value)} className="form-control" required name="state">
                <option disabled selected value="">
                  Select State
                </option>
                {statesList?.map(item => (
                  <option value={item.value}>{item.value}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </td>
          <td>
            <Form.Group controlId="licenseId">
              <Form.Control
                defaultValue={licenceClone?.licenseId || ''}
                onChange={e => (licenceClone.licenseId = e.target.value)}
                required
                name="licenseId"
                placeholder="NPI Number"
                type="text"
              />
            </Form.Group>
          </td>
          <td>
            <Form.Group controlId="expirationDate">
              <Form.Control
                defaultValue={licenceClone?.expirationDate || ''}
                onChange={e => (licenceClone.expirationDate = e.target.value)}
                required
                name="expirationDate"
                placeholder="Date"
                type="date"
              />
            </Form.Group>
          </td>
          <td>
            <Form.Group controlId="isGoodStanding">
              <Form.Select
                defaultValue={licenceClone?.isGoodStanding || ''}
                onChange={e => (licenceClone.isGoodStanding = e.target.value)}
                className="form-control"
                required
                name="isGoodStanding"
                id="isGoodStanding"
              >
                <option disabled selected value="">
                  Good Standing
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Form.Select>
            </Form.Group>
          </td>
          <td>
            <Form.Group controlId="ackPermissionToPractice">
              <Form.Select
                defaultValue={licenceClone?.ackPermissionToPractice || ''}
                onChange={e => (licenceClone.ackPermissionToPractice = e.target.value)}
                className="form-control"
                required
                name="ackPermissionToPractice"
                id="ackPermissionToPractice"
              >
                <option disabled selected value="">
                  Acknowledge permission to practice ?
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Form.Select>
            </Form.Group>
          </td>

          <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
            <Button
              variant="light"
              onClick={() => handleConfirmChange().then(r => r)}
              style={{
                width: 'auto',
                height: 'auto',
                borderRadius: 8,
                backgroundColor: 'rgba(0, 127, 97, 1)',
                color: 'rgba(253, 250, 241, 1)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              <img alt="done" src={checkIcon} style={{ height: 12, objectFit: 'contain', filter: 'invert(1)' }} />
              &nbsp;&nbsp;<span style={{ whiteSpace: 'nowrap' }}>Confirm</span>
            </Button>
          </td>

          <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
            <Button
              variant="light"
              onClick={() => handleDiscardChanges()}
              style={{
                width: 'auto',
                height: 'auto',
                borderRadius: 8,
                backgroundColor: 'red',
                color: 'rgba(253, 250, 241, 1)',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              &nbsp;&nbsp;<span style={{ whiteSpace: 'nowrap' }}>Discard</span>
            </Button>
          </td>

          {/* <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
            <Button
              variant="light"
              onClick={() => handleDiscardChanges()}
              style={{
                width: 'auto',
                paddingInline: 20,
                height: 40,
                marginLeft: 20,
                borderRadius: 8,
                backgroundColor: 'red',
                fontSize: 20,
                fontWeight: '600',
                lineHeight: '100%',
                color: 'rgba(253, 250, 241, 1)',
                border: 'none',
                marginRight: 40,
                letterSpacing: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              X &nbsp;&nbsp;<span style={{ whiteSpace: 'nowrap' }}>Discard</span>
            </Button>
          </td> */}
        </tr>
      </>
    )
}

export default LicenseEditRow;